// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import VueAnimateNumber from 'vue-animate-number'
import CheckView from 'vue-check-view'
import vClickOutside from 'v-click-outside'

import App from './App'
import router from './router'

import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import MemberProfile from './components/MemberProfile.vue'
import SlidesPagination from './components/SlidesPagination.vue'
import DateFilter from './filters/Date'

require('../node_modules/fullpage.js/vendors/scrolloverflow.min.js')
require('../node_modules/fullpage.js/dist/fullpage.extensions.min.js')

Vue.mixin({
  filters: {
    date: DateFilter
  }
})

Vue.use(CheckView)
Vue.use(VueAnimateNumber)
Vue.use(vClickOutside)
Vue.component('GPHeader', Header)
Vue.component('GPFooter', Footer)
Vue.component('MemberProfile', MemberProfile)
Vue.component('SlidesPagination', SlidesPagination)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js